module.exports = __webpack_public_path__ + "img/3.1b4b14ca.png";